<template>
  <div ref="container">
    <div @click="isOpen=!isOpen">
      <slot name="input" :value="value">
        <span v-if="value&&(!isMultiValueMode()||value.length)" :class="isMultiValueMode()?'ui label':'text'"> {{title([].concat(value)[0])}} </span>
        <span v-if="isMultiValueMode()&&value.length>1" class="ui label"> +{{value.length-1}}</span>
        <span v-if="!value" class="default text">{{defText}}</span>
        <!-- вставляем символ пробела для сохранения высоты строки-->&zwnj;
        <i v-if="inputIconClass" :class="inputIconClass" style="opacity: 0.5;float:right"></i>
      </slot>
    </div>
    <div :class="menuClass + (isOpen?' transition visible':'')" style="min-width: 0 !important;"
         :style="[styleObject,menuStyle]"
         @click="isMultiValueMode()||value===undefined?'void':isOpen=false">
      <slot>
        <div v-for="(option,index) in options" :class="{selected : isSelected(option)}" class="item"
             @click="$emit('input',option)">
          {{title(option)}}
        </div>
        <div v-if="emptyText&&(!options.length)" class="item"> {{emptyText}}</div>
      </slot>
    </div>
  </div>
</template>

<script>
  import {isEqual, isArray} from 'lodash'

  export default {
    name: "dropdown-element",
    props: {
      value: {},
      options: {
        type: Array
      },
      isAbsolut: {
        type: Boolean,
        default: false
      },
      inputIconClass: {
        type: String
      },
      label: {
        type: String,
        default: 'label'
      },
      menuClass: {
        type: String,
        default: 'ui menu'
      },
      menuStyle: {
        type: String,
        default: ''
      },
      defText: {
        type: String,
        default: ''
      },
      emptyText: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        isOpen: false,
      }
    },
    // created(){
    //   console.log(this.value)
    // },
    computed: {
      styleObject() {
        return {
          display: this.isOpen ? 'block !important' : '',
          position: this.isOpen && this.isAbsolut ? 'fixed' : '',
          top: this.isOpen && this.isAbsolut ? (this.$refs.container.getBoundingClientRect().y + 10) + 'px' : '',
          left: this.isOpen && this.isAbsolut ? this.$refs.container.getBoundingClientRect().x + 'px' : ''
        }
      }
    },
    methods: {
      globalClickListener(e) {
        if (this.$refs.container.contains(e.target)) return;
        if (this.isOpen) this.isOpen = false;
      },
      title(value) {
        return typeof value === 'object' ? value[this.label] || value['title'] || value : value;
      },
      isSelected(option) {
        return [].concat(this.value).some(v => isEqual(option, v))
      },
      isMultiValueMode() {
        return isArray(this.value)
      }
    },
    watch: {
      isOpen(newValue) {
        this.$emit('isOpen', newValue)
      }
    },
    mounted() {
      document.body.addEventListener('click', this.globalClickListener)
    },
    destroyed() {
      document.body.removeEventListener('click', this.globalClickListener)
    },
  }
</script>

<style scoped>

</style>
